import { InfoIcon } from '@/components/common/InfoIcon';
import { t } from '@/i18n';
import styles from './DesktopSpreadAside.module.css';

const tips = [
  {
    icon: String.fromCodePoint(0x1f4f7),
    lead: t.spread.aside.tips.photo.lead,
    body: t.spread.aside.tips.photo.body,
  },
  {
    icon: String.fromCodePoint(0x1f4ac),
    lead: t.spread.aside.tips.question.lead,
    body: t.spread.aside.tips.question.body,
  },
  {
    icon: String.fromCodePoint(0x1f552),
    lead: t.spread.aside.tips.time.lead,
    body: t.spread.aside.tips.time.body,
  },
] as const;

export function DesktopSpreadAside() {
  return (
    <aside className={styles.panel}>
      <h3 className={styles.h}>
        <InfoIcon size={20} />
        {t.spread.aside.title}
      </h3>
      <p className={styles.intro}>{t.spread.aside.intro}</p>
      <ul className={styles.cards}>
        {tips.map((tip) => (
          <li key={tip.lead} className={styles.card}>
            <span className={styles.cardIco} aria-hidden>
              {tip.icon}
            </span>
            <p className={styles.cardText}>
              <strong>{tip.lead}</strong>
              {tip.body}
            </p>
          </li>
        ))}
      </ul>
    </aside>
  );
}
